/**
 * Russian sentences for the ways a save can fail before the server's business
 * rules even look at it: a zod issue list (ours before sending, or the
 * admin-api's `zValidator` 400 body) and a dead connection. The raw texts —
 * «Invalid input: expected string, received number», «Failed to fetch»,
 * «Bad Request» — tell an operator nothing.
 */
const FIELD_RU = {
    name: 'название',
    key: 'ключ',
    enabled: 'включён',
    trigger: 'условие запуска',
    definition: 'схема',
    entryNodeId: 'первый шаг',
    params: 'параметры',
};
/** `definition.nodes.ask.params.question` → «схема → шаг «ask» → параметры → question». */
export const issuePathRu = (path) => {
    const parts = [];
    for (let i = 0; i < path.length; i++) {
        const seg = String(path[i]);
        if (seg === 'nodes' && i + 1 < path.length) {
            parts.push(`шаг «${String(path[i + 1])}»`);
            i++;
            continue;
        }
        parts.push(FIELD_RU[seg] ?? seg);
    }
    return parts.join(' → ');
};
const CODE_RU = {
    invalid_type: 'не то значение или не заполнено',
    too_small: 'слишком короткое или пустое',
    too_big: 'слишком длинное',
    invalid_format: 'неверный формат',
    invalid_value: 'недопустимое значение',
    invalid_union: 'не подходит ни под один вариант',
    unrecognized_keys: 'лишние поля',
    invalid_key: 'неверный ключ',
    invalid_element: 'неверный элемент',
    not_multiple_of: 'неверное число',
};
/**
 * One issue → «шаг «ask» → параметры → question: слишком короткое или пустое».
 * A `custom` issue (the engine's refinements: dangling `next`, unreachable
 * entry…) keeps its own message — it is a sentence about the graph, not a type.
 */
export const issueRu = (issue) => {
    const where = issue.path && issue.path.length > 0 ? `${issuePathRu(issue.path)}: ` : '';
    const what = (issue.code !== undefined ? CODE_RU[issue.code] : undefined) ??
        issue.message ??
        'неверное значение';
    return `${where}${what}`;
};
/** At most `max` issues, then «и ещё N». */
export const issuesRu = (issues, max = 3) => {
    const shown = issues.slice(0, max).map(issueRu);
    const rest = issues.length - shown.length;
    return rest > 0 ? `${shown.join('; ')} и ещё ${rest}` : shown.join('; ');
};
const isIssueArray = (v) => Array.isArray(v) && v.every((x) => typeof x === 'object' && x !== null);
/**
 * The issues of a `@hono/zod-validator` 400 body — `{ success: false, error:
 * ZodError }`, where zod 4 serialises the error as `{ name, message }` and the
 * message is the issue list as JSON. `null` for any other body.
 */
export const issuesFromValidatorBody = (body) => {
    if (typeof body !== 'object' || body === null)
        return null;
    const b = body;
    if (b.success !== false || typeof b.error !== 'object' || b.error === null)
        return null;
    const err = b.error;
    if (isIssueArray(err.issues))
        return err.issues;
    if (typeof err.message !== 'string')
        return null;
    try {
        const parsed = JSON.parse(err.message);
        return isIssueArray(parsed) ? parsed : null;
    }
    catch {
        return null;
    }
};
export const NETWORK_ERROR_RU = 'Нет связи с сервером — проверьте интернет и попробуйте ещё раз. Правки остаются на странице.';
export const SESSION_EXPIRED_RU = 'Сессия истекла — войдите снова в соседней вкладке и нажмите «Сохранить» здесь: правки остаются на странице.';
export const FORBIDDEN_RU = 'Нет прав на изменение пайплайнов.';
//# sourceMappingURL=errors.js.map